import { render, staticRenderFns } from "./PlanningItemSummary.vue?vue&type=template&id=98156c7e"
import script from "./PlanningItemSummary.vue?vue&type=script&lang=ts"
export * from "./PlanningItemSummary.vue?vue&type=script&lang=ts"
import style0 from "./PlanningItemSummary.vue?vue&type=style&index=0&id=98156c7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports